import { render, staticRenderFns } from "./PwaApcnPopupTableInfo5.vue?vue&type=template&id=13af0100&"
import script from "./PwaApcnPopupTableInfo5.vue?vue&type=script&lang=js&"
export * from "./PwaApcnPopupTableInfo5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports